module.exports = __webpack_public_path__ + "static/media/IMG_2648.f1611d34.jpg";